var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCarouselIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "VideoCarousel",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "VideoCarousel",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87 7.65a.4.4 0 010 .7L6.6 10.17a.4.4 0 01-.6-.35V6.18c0-.3.33-.5.6-.35l3.27 1.82z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3c0-1.1.9-2 2-2h6a2 2 0 012 2h1a2 2 0 012 2v6a2 2 0 01-2 2h-1a2 2 0 01-2 2H5a2 2 0 01-2-2H2a2 2 0 01-2-2V5c0-1.1.9-2 2-2h1zm2 0h6v10H5V3zM3 5H2v6h1V5zm10 6h1V5h-1v6z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgVideoCarouselIcon;